import Swiper from "swiper/bundle"

export const swiperInit = () => {
    let swiper = new Swiper(".InterSwiper", {
        slidesPerView: "auto",
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize: innerWidth * 0.32002314814814814814814814814814814814
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    window.swiper = {}

    window.swiper.job = new Swiper(".jobSwiper", {
        slidesPerView: "auto",
        allowTouchMove: false,
        effect: 'fade',
        speed: 150,
        fadeEffect: {
            crossFade: true
        },
    });
}

{
    /* <div class="swiper mySwiper">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <figure>
                    <img src="" alt="" />
                </figure>
            </div>
        </div>
    </div> */

    // @import '../../node_modules/swiper/swiper-bundle.min.css';

}